export function getUserLimitations(userService): Promise<any> {
  return new Promise((resolve, reject) => {
    userService.getLimitations()
      .subscribe(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
}
